export enum DigitalShareAppType {
  Mobilytics = "Mobilytics",
  RetailMatch = "Retail Match",
}

export enum DigitalShareAppImage {
  Mobilytics = "/Images/Digital Share/BuxtonMobilytics.svg",
  RetailMatch = "/Images/Digital Share/BuxtonMatch.svg",
}
